import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import { validateProperty, validate } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import services from '../services';
import MenuItem from '@material-ui/core/MenuItem';
import $ from 'jquery';
import { fieldUserMappingSchemaObject } from '../fieldUserMappingSchema';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import FormHelperText from '@material-ui/core/FormHelperText';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import Chip from '@material-ui/core/Chip';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const screenCode = 'FIELDUSERMAPPING'

export function Listing(props) {
    const [fieldUserMapping, setFieldUserMapping] = useState([]);
    const [fieldUserMappingSearch, setFieldUserMappingSearch] = useState({
        groupID: 0,
        operationEntityID: 0,
        collectionPointID: 0,
        userID: 0
    });
    const [groups, setGroups] = useState()
    const [operationEntities, setOperationEntities] = useState([]);
    const [devisions, setDevisions] = useState()
    const [users, setUsers] = useState()
    const [isTableHide, setIsTableHide] = useState(true);
    const [errors, setErrors] = useState({});
    const [open, setOpen] = React.useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const schema = Joi.object(fieldUserMappingSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [fieldUserMappingSearch.groupID])

    useEffect(() => {
        trackPromise(
            getDevisions()
        )
    }, [fieldUserMappingSearch.operationEntityID])

    useEffect(() => {
        trackPromise(
            getUsers()
        )
    }, [fieldUserMappingSearch.collectionPointID])

    useEffect(() => {
        destroyDataTable();
    }, [fieldUserMappingSearch.userID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFIELDUSERMAPPING');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITFIELDUSERMAPPING');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities.length > 0) {
            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }
            setMultipleEstates(estateArray)
        }
        setFieldUserMappingSearch({
            ...fieldUserMappingSearch,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        getAllGroups();
    }

    async function getDevisions() {
        const result = await services.getDivisions(fieldUserMappingSearch.operationEntityID)
        setDevisions(result)
    }

    async function getOperationEntities() {
        const operationEntityList = await services.getOperationEntitiesByGroupForDropDown(fieldUserMappingSearch.groupID);
        setOperationEntities(operationEntityList);
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getUsers() {
        const result = await services.getUsers(fieldUserMappingSearch.collectionPointID);
        setUsers(result)
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
        setIsTableHide(true);
    }

    function createDataTable() {
        $('#example').DataTable({
            stripeClasses: [],
            searching: false,
        });
    }

    async function handleClick(data) {
        const modifiedBy = parseInt(tokenService.getUserIDFromToken())
        const response = await services.FieldUserMappingDelete(data.userAssignCollectionPointID, modifiedBy)
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)
        setOpen(false);
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true })
            }, 1500);
            handleSearch()
        }
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    async function getFieldUserMappingData(userID) {
        const data = await services.getFieldUserMappingList(userID);
        return data;
    }

    function handleGroupChange(target) {
        validateInputs(target);
        setFieldUserMappingSearch({
            ...fieldUserMappingSearch,
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID: '0',
            userID: '0'
        })
    }

    function handleEstateChange(target) {
        validateInputs(target);
        setFieldUserMappingSearch({
            ...fieldUserMappingSearch,
            operationEntityID: target.value,
            collectionPointID: '0',
            userID: '0'
        })
    }

    function handleDivisionChange(target) {
        validateInputs(target);
        setFieldUserMappingSearch({
            ...fieldUserMappingSearch,
            collectionPointID: target.value,
            userID: '0'
        })
    }

    function handleUserChange(target) {
        validateInputs(target);
        setFieldUserMappingSearch({
            ...fieldUserMappingSearch,
            userID: target.value
        })
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, fieldUserMappingSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setErrors(error)
    }

    async function handleSearch() {
        destroyDataTable();
        setIsTableHide(true);
        setFieldUserMapping([]);
        const validationData = {
            groupID: parseInt(fieldUserMappingSearch.groupID),
            operationEntityID: parseInt(fieldUserMappingSearch.operationEntityID),
            collectionPointID: parseInt(fieldUserMappingSearch.collectionPointID),
            userID: parseInt(fieldUserMappingSearch.userID)
        };
        const errorMessages = validate(schema, validationData);
        if (errorMessages) {
            const filteredErrors = { ...errorMessages };
            delete filteredErrors.allowDivisionID;
            if (Object.keys(filteredErrors).length > 0) {
                setErrors(filteredErrors);
                return;
            }
        }
        var data = await getFieldUserMappingData(fieldUserMappingSearch.userID);
        if (data.length > 0) {
            setIsTableHide(false);
            setFieldUserMapping(data);
            createDataTable();
        } else {
            setIsTableHide(true);
            setFieldUserMapping([]);
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Warning",
                disciption: "No mapped data found for the selected user"
            });

            setTimeout(() => {
                setMessageModel(prev => ({
                    ...prev,
                    hidden: true
                }));
            }, 5000);
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setFieldUserMappingSearch({
            ...fieldUserMappingSearch,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionPointID: '0',
            userID: '0'
        });
        destroyDataTable();
        setFieldUserMapping([]);
        setIsTableHide(true);
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    function handleClose() {
        setOpen(false);
        setSelectedItem(null);
    }

    function handleClickOpen(item) {
        setSelectedItem(item);
        setOpen(true);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Field User Mapping"
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    buttonText="Add Field User Mapping"
                                    path="FieldUserMapping/addEdit" />
                            </div>
                            <hr />

                            <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={fieldUserMappingSearch.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={fieldUserMappingSearch.operationEntityID}
                                            onChange={(e) => handleEstateChange(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(
                                                Object.fromEntries(
                                                    Object.entries(operationEntities).filter(([key, value]) => {
                                                        if (key === "0" || !value) return false;
                                                        if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                                                            return true;
                                                        }
                                                        return Object.values(multipleEstates).includes(value);
                                                    })
                                                )
                                            )}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={fieldUserMappingSearch.collectionPointID}
                                            onChange={(e) => handleDivisionChange(e.target)}>
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(devisions)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="userID">User *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="userID"
                                            name="userID"
                                            value={fieldUserMappingSearch.userID}
                                            onChange={(e) => handleUserChange(e.target)}>
                                            <MenuItem value="0">--Select User--</MenuItem>
                                            {generateDropDownMenu(users)}
                                        </Select>
                                        {errors["userID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["userID"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={(e) => handleSearch(e)}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            <div className="table-responsive row-top-gap">
                                <table id="example" className="display dataTable no-footer" hidden={isTableHide}>
                                    <thead>
                                        <tr>
                                            <th>Assigned Collection Point</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fieldUserMapping.map((row, index) => (
                                            <tr key={index}>
                                                <td>{row.collectionPointName}</td>
                                                <td>
                                                    {row.isActive ?
                                                        <Chip size="small" label="Active" style={{ color: 'green' }} /> :
                                                        <Chip size="small" label="Inactive" style={{ color: 'red' }} />
                                                    }
                                                </td>
                                                <td>
                                                    {permissionList.isAddEditEnabled ? (
                                                        <IconButton
                                                            variant="outlined"
                                                            color="primary"
                                                            onClick={() => handleClickOpen(row)}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    ) : '-'}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Delete "}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to Delete?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        No
                    </Button>
                    <Button onClick={() => handleClick(selectedItem)} color="primary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    )
}